import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { FrontendConfig } from './core/interfaces/frontend-config';
import { ThemeService } from './core/services/theme.service';
import { ConfigurationStore } from './core/stores/configuration.store';
import { ConfigService } from './core/services/config.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonicModule]
})
export class AppComponent {
  isIframe = false;
  configuration!: FrontendConfig;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon')!;
  illustrationPhoto: string;

  constructor(private cdr: ChangeDetectorRef,
    private themeService: ThemeService,
    private configurationStore: ConfigurationStore,
    private config: ConfigService) {
    this.illustrationPhoto = this.config.getSettings("msal.blobStorageIllustrationPhotos");
  }

  ngOnInit(): void {
    this.favIcon.href = this.illustrationPhoto + '/FavIcon.png';
    this.isIframe = window !== window.parent && !window.opener;

    // portalConfiguration is loaded by the APP_INITIALIZER before bootstrap, so it's always available here
    this.configuration = this.configurationStore.config!;
    if (this.configuration) {
      this.applyTheme(this.configuration.ColorThemeModeString);
    }

    this.configurationStore.config$.subscribe((config: FrontendConfig | null) => {
      if (config) {
        this.configuration = config;
        this.applyTheme(config.ColorThemeModeString);
        this.cdr.detectChanges();
      }
    });
  }

  private applyTheme(colorMode: string): void {
    if (colorMode === 'Dark') {
      this.themeService.setDarkTheme();
    } else {
      this.themeService.setLightTheme();
    }
  }
}
